module.exports = "/images/Poland.png?3902d948c969f9b488e49e1f2028df2b";